
export const camelize = str => str.split` `.map((word, i) => i ? word[0].toUpperCase() + word.slice(1) : word).join``;